/**
 * Progress component type definitions
 */

export enum ProgressSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum ProgressVariant {
  Default = 'default',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
